import React from 'react'
import { Block } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import './style.css'

const RefundPolicy = ({ refundPolicy }) => {
    return (
        <Block isRender={refundPolicy}>
            <SectionCard icon="mdi:cash-refund" titleKey="refund-policy-header">
                <div className="refund-policy-content">
                    <p>{refundPolicy}</p>
                </div>
            </SectionCard>
        </Block>
    )
}

export default RefundPolicy

